import { z } from 'zod';

import {
  zMessageContentPartImageUrl,
  zMessageContentPartLangChainMultimodal,
  zMessageContentPartOpenAIFile,
  zMessageContentPartText,
} from '@/types/schema';

import { SMALL_STRING_LIMIT } from './constants';

const zMessageToolUsePart = z.object({
  type: z.literal('tool_use'),
  id: z.string(),
  name: z.string(),
  input: z.union([z.record(z.unknown()), z.string()]),
});

export const zMessage = z
  .object({
    id: z.string().optional(),
    content: z.union([
      z.string(),
      z.array(
        z.union([
          zMessageContentPartText,
          zMessageToolUsePart,
          zMessageContentPartOpenAIFile,
          zMessageContentPartImageUrl,
          zMessageContentPartLangChainMultimodal,
        ])
      ),
    ]),
    type: z.string().optional(),
    role: z.string().optional(),
    name: z.union([z.string(), z.null()]).optional(),
    tool_calls: z
      .array(
        z.object({
          args: z.record(z.unknown()),
          id: z.string().optional(),
          name: z.string(),
        })
      )
      .optional(),
  })
  .refine(({ role, type }) => !!(type || role), {
    message: 'Role or type must be present in message',
  });

export const isMessageSmall = (msg: Message): boolean => {
  return msg.content.length < SMALL_STRING_LIMIT;
};

// TODO
export type Message =
  // BaseMessage .to_dict() representation
  z.infer<typeof zMessage>;

export type MessageToolUsePart = z.infer<typeof zMessageToolUsePart>;

export const zMessages = z.array(zMessage).min(1);

// TODO
export const messageLabel = (msg: Message): string | undefined => {
  return messageType(msg);
};
// TODO
export const messageContent = (msg: Message): Message['content'] => {
  return msg['content'];
};

// TODO
export const messageType = (msg: Message): string => {
  return msg['role'] || msg['type'] || 'human';
};
